import React from "react";
import { Box, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import useNetworkStatus from "../../../../../../helper/NetworkStatus";
import { ShimmerSimpleGallery } from "react-shimmer-effects";

const Launched = () => {
  const { isOnline } = useNetworkStatus();

  return (
    <Box sx={{ px: 3, py: 4 }}>
      {isOnline ? (
        <Box textAlign="center">
          <AccessTimeIcon
            sx={{
              fontSize: 60,
              color: "#1B6EF4",
              mb: 1,
            }}
          />
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, color: "#052659" }}
          >
            Coming Soon
          </Typography>
        </Box>
      ) : (
        <ShimmerSimpleGallery
          card
          imageHeight={180}
          row={3}
          col={3}
          gap={20}
        />
      )}
    </Box>
  );
};

export default Launched;
